import React, { useMemo } from 'react';
import { Colors, Flex, IconMinus, IconPlus, Typography } from '@banhala/ui-kit';

export const CounterStepper: React.FC<{
  min: number;
  max: number;
  value: number;
  onChangeValue: (nextVal: number) => void;
}> = props => {
  const disabled = useMemo(() => {
    return {
      min: props.min === props.value,
      max: props.max === props.value,
    };
  }, [props.max, props.min, props.value]);

  return (
    <Flex.Row alignItems={'center'} gap={12}>
      <Flex.Center
        borderRadius={14}
        width={28}
        height={28}
        borderWidth={1}
        borderColor={'border_tertiary'}
        backgroundColor={
          disabled.min ? 'bg_disabled_primary' : 'bg_always_white'
        }
        onPress={() => {
          if (disabled.min) return;
          props.onChangeValue(Math.max(0, props.value - 1));
        }}
      >
        <IconMinus
          size={16}
          fill={
            disabled.min ? Colors.content_disabled : Colors.content_secondary
          }
        />
      </Flex.Center>
      <Typography>{props.value}</Typography>
      <Flex.Center
        borderRadius={14}
        width={28}
        height={28}
        borderWidth={1}
        borderColor={'border_tertiary'}
        backgroundColor={
          disabled.max ? 'bg_disabled_primary' : 'bg_always_white'
        }
        onPress={() => {
          if (disabled.max) return;
          props.onChangeValue(Math.min(props.max, props.value + 1));
        }}
      >
        <IconPlus
          size={16}
          fill={
            disabled.max ? Colors.content_disabled : Colors.content_secondary
          }
        />
      </Flex.Center>
    </Flex.Row>
  );
};
